<template>
  <SModal
    v-bind="$attrs"
    v-model="localShowModal"
    :header-title="$t('ui.alternative_text.modal.title')"
    :show-footer-gradient="false"
    data-test="add-edit-alt-text-modal"
    @hide="(ev) => $emit('close', ev)"
  >
    <VForm
      v-if="localShowModal"
      id="form-add-edit-alt-text"
      :initial-values="initialFormValues"
      class="d-flex flex-column align-items-center"
      @submit="submitAltText"
    >
      <p class="text-center text-muted f-14 mb-0">{{ $t('ui.alternative_text.modal.description') }}</p>

      <img :src="imagePreviewSrc"
           :alt="localAltText || ''"
           data-test="image-preview"
           class="image-preview"
           loading="lazy"
      />

      <STextarea
        v-model="localAltText"
        validation-rules="max:200"
        validation-field-name="alt_text"
        spellcheck="true"
        class="w-100"
        :label-text="$t('ui.alternative_text.modal.textarea_placeholder')"
        hide-label
        :placeholder="$t('ui.alternative_text.modal.textarea_placeholder')"
        :rows="4"
        no-resize
        test-id="input-add-edit-alt-text"
      />
    </VForm>

    <template #modal-footer>
      <b-button
        v-btn-focus-restore-after-disable
        variant="primary"
        type="submit"
        form="form-add-edit-alt-text"
        block
        size="lg"
        :class="{ 'spinner-btn': isWaiting }"
        :disabled="isWaiting"
        data-test="submit-add-edit-alt-text"
      >
        {{ $t('global.save') }}
      </b-button>
    </template>
  </SModal>
</template>

<script>
export default {
  name: 'AddEditAltText',
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    imagePreviewSrc: {
      type: String,
      required: true,
    },

    currentAltText: {
      type: String,
      default: '',
    },

    isWaiting: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    localShowModal: false,
    localAltText: '',
  }),

  emits: ['close', 'submit'],

  computed: {
    initialFormValues() {
      return {
        alt_text: this.localAltText,
      }
    },
  },

  methods: {
    async submitAltText() {
      this.$emit('submit', this.localAltText)
    },
  },

  watch: {
    showModal: {
      handler(newVal) {
        this.localShowModal = newVal
        this.localAltText = this.currentAltText
      },

      immediate: true,
    },
  },
}
</script>

<style scoped lang="scss">
.image-preview {
  max-width: 100%;
  max-height: 400px;
  padding: 24px;
}
</style>
